"use client";
import { useState } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { Icon } from "@zapier/zinnia-icons";
import { Link as DSLink, Text } from "@zapier/design-system";
import styles from "./SidebarMenu.module.css";
import classNames from "classnames";
import { ServiceRoute } from "src/utils/routes";
import Link from "next/link";
interface SidebarMenuProps {
  defaultOpen?: boolean;
  menu: ServiceRoute[];
  title: string;
  hideIfEmpty?: boolean;
}

export const SidebarMenu = ({
  defaultOpen,
  menu,
  title,
  hideIfEmpty = false,
}: SidebarMenuProps) => {
  const [open, setOpen] = useState(!!defaultOpen);

  if (hideIfEmpty && menu.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={styles.title}>
        <button
          className={classNames(styles.iconWrapper, {
            [styles.open]: open,
            [styles.closed]: !open,
          })}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <Icon name="arrowSmallDown" size={24} />
        </button>
        <Text type="Body3">{title}</Text>
      </div>
      {open ? (
        <div>
          {menu.map((item) => (
            <SidebarMenuItem key={item.text} item={item} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export const HomepageMenuItem = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const text = "All templates";

  const href = searchParams?.toString() ? `${pathname}` : "/templates";

  return (
    <div className={styles.homepageMenuItem}>
      <DSLink href={href} className={styles.styledLink} component={Link}>
        <Text type="Body3">{text}</Text>
      </DSLink>
    </div>
  );
};

export const SidebarMenuItem = ({
  item,
  className,
}: {
  item: ServiceRoute;
  className?: string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentUrl = searchParams?.toString()
    ? `${pathname}?${searchParams.toString()}`
    : pathname;

  const isCurrentPage = currentUrl === item.href;

  return (
    <div
      key={item.text}
      className={classNames(styles.sidebarMenuItem, className, {
        [styles.active]: isCurrentPage,
      })}
    >
      <DSLink
        href={item.href}
        onClick={item.onClick}
        className={styles.styledLink}
        component={Link}
      >
        <Text type="Body1" color="GrayWarm9">
          {item.text}
        </Text>
      </DSLink>
    </div>
  );
};
